import "./App.css";
import { Routes, Route } from "react-router-dom";
import MapPage from "./MapPage";
import JeopardyHome from "./jeopardy/JeopardyHome";
import GameSelect from "./jeopardy/GameSelect";
import BoardBuilder from "./jeopardy/BoardBuilder";
import JeopardyRoom from "./jeopardy/JeopardyRoom";

export default function App() {
    return (
        <Routes>
            <Route path="/" element={<MapPage />} />
            <Route path="/jeopardy" element={<JeopardyHome />} />
            <Route path="/jeopardy/host" element={<GameSelect />} />
            <Route path="/jeopardy/builder" element={<BoardBuilder />} />
            <Route path="/jeopardy/:code" element={<JeopardyRoom />} />
        </Routes>
    );
}
